import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Paper,
  Typography,
  Grid,
  Radio,
  RadioGroup,
  MenuItem,
  FormControlLabel,
  FormControl,
  CircularProgress,
  createTheme,
  ThemeProvider,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { InputAdornment } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import axios from 'axios';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#fff', // Adjust the color according to your preference
    },
    background: {
      default: '#333', // Adjust the color according to your preference
      paper: '#333', // Adjust the color according to your preference
    },
    text: {
      primary: '#fff', // Adjust the color according to your preference
    },
  },
})

const LoginForm = ({ onLoginSuccess }) => {
  const [yearMasterEntries, setYearMasterEntries] = useState([]);
  const [companyMasterEntries, setCompanyMasterEntries] = useState([]);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [changePasswordMode, setChangePasswordMode] = useState(false);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [oldDBPassword, setOldDBPassword] = useState('');
  const [newDBPassword, setNewDBPassword] = useState('');
  const [confirmDBPassword, setConfirmDBPassword] = useState('');

  const [error, setError] = useState(null);
  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [clientIdError, setClientIdError] = useState(false);

  const [isDatabaseConnected, setIsDatabaseConnected] = useState(false);
  const [isCredentialsValidated, setIsCredentialsValidated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loading1, setLoading1] = useState(false); 

  const [CompCode, setCompCode] = useState('');
  const [companyCode, setCompanyCode] = useState('');
  const [dbcompanyCode, setdbcompanyCode] = useState('');
  const [financialYear, setFinancialYear] = useState('');

  const [clientId, setClientId] = useState('');
  const [DBpassword, setDBPassword] = useState('');

  // const [loading, setLoading] = useState(false); // Introduce loading state

  const navigate = useNavigate();

  useEffect(() => {
    fetchCompanyMaster();
    //fetchYearMaster();

  }, []);

  const fetchCompanyMaster = async () => {
    try {
      setLoading(true);
      const response = await axios.get('https://www.wingap.net.in/api/company_code');
      setLoading(false);
      setCompanyMasterEntries(response.data);
      setCompanyCode(response.data[0].CompCode);
     // console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchYearMaster = async (compCode) => {
    try {
      //console.log("Year Master CompCode ", compCode);
      const response = await axios.get(`https://www.wingap.net.in/api/database_year_master/${compCode}`);
      setYearMasterEntries(response.data);
      setFinancialYear(response.data[0].FinancialYear);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const handleUsername = (event) => {
    setUsername(event.target.value);
    setUsernameError(false); // Reset error state
  };

  const handleClientIdChange = (event) => {
    setClientId(event.target.value);
    setClientIdError(false);
  };

  const handlePassword = (event) => {
    setPassword(event.target.value);
    setUsernameError(false); // Reset error state
  };

  const handleOldPasswordChange = (event) => {
    setOldPassword(event.target.value);
  };

  const handleNewPasswordChange = (event) => {
    setNewPassword(event.target.value);
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
  };

  const handleDBPassword = (event) => {
    setDBPassword(event.target.value);
    setPasswordError(false); // Reset error state
  };

  const handleOldDBPasswordChange = (event) => {
    setOldDBPassword(event.target.value);
  };

  const handleNewDBPasswordChange = (event) => {
    setNewDBPassword(event.target.value);
  };

  const handleConfirmDBPasswordChange = (event) => {
    setConfirmDBPassword(event.target.value);
  };

  const handleToggleChangePassword = () => {
    setChangePasswordMode(!changePasswordMode);
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setLoading1(true);
    try {
      const response = await axios.post('https://www.wingap.net.in/api/login', {
        username,
        password,
      });

      if (response.status === 200) {
        const { message, username: loggedInUsername } = response.data;
        //console.log("Message", message);
        onLoginSuccess(loggedInUsername);
        navigate('/SelectCompany');
        setLoading(false);
        setLoading1(false);
      } else {
        const errorResponse = await response.json();
        console.error('Failed to log in');
        toast.error(errorResponse.error, { position: toast.POSITION.BOTTOM_CENTER });
        setLoading(false);
        setLoading1(false);
        setError(errorResponse.error);
        setUsernameError(true);
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error( "Invalid Credential", { position: toast.POSITION.BOTTOM_CENTER, autoClose:705 },);
      setUsernameError(true);
      setLoading(false);
      setLoading1(false); 
    } finally {
      setLoading(false);
      setLoading1(false);
    }
  };

  const handleChangePassword = async () => {
    try {
      const response = await fetch('https://www.wingap.net.in/api/change-password', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, oldPassword, newPassword }),
      });

      const data = await response.json();

      if (response.ok) {
        setUsername('');
        setPassword('');
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
        handleToggleChangePassword();
        // console.log(data.message); // Password change successful
      } else {
        setUsername('');
        setPassword('');
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
        console.error(data.error); // Log the error message
        alert('Password Change failed');
      }
    } catch (error) {
      console.error('Error:', error);
      //console.log('Password change failed');
    }
  };

  const handleChangeDBPassword = async () => {
    try {
      const response = await fetch('https://www.wingap.net.in/api/DB-change-password', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ clientId, oldDBPassword, newDBPassword }),
      });

      const data = await response.json();

      if (response.ok) {
        setClientId('');
        setDBPassword('');
        setOldDBPassword('');
        setNewDBPassword('');
        setConfirmDBPassword('');
        handleToggleChangePassword();
        // console.log(data.message); // Password change successful
      } else {
        setUsername('');
        setPassword('');
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
        console.error(data.error); // Log the error message
        alert('Password Change failed');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleDBSubmit = async (event) => {
    event.preventDefault();
    setLoading1(false);

    try {
      const response = await fetch('https://www.wingap.net.in/api/dblogin', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ clientId, DBpassword, dbcompanyCode }),
      });
      if (response.ok) {
        const responseData = await response.json();
        const loggedInUsername = responseData.compCode;
        //console.log("USERNAME ", loggedInUsername);
        setdbcompanyCode(loggedInUsername);
        //console.log('Login successful');
        fetchYearMaster(loggedInUsername);

        setIsCredentialsValidated(true);
        setLoading1(false);
      } else {
        const errorResponse = await response.json();
        //console.log('Login failed');
        toast.error(errorResponse.error, { position: toast.POSITION.BOTTOM_CENTER, autoClose:705 });
        console.log('Error Response:', errorResponse.error);
        setError(errorResponse.error);
        setPasswordError(true);
      }
    } catch (error) {
      console.log('Error:', error);
      toast.error('An unexpected error occurred.', { position: toast.POSITION.BOTTOM_CENTER });
    }
  };

  const connectToDatabase = () => {
    if (!dbcompanyCode) {
      setUsernameError(true);
      return;
    }
    setLoading1(true);

    axios.post('https://www.wingap.net.in/api/connect', { dbcompanyCode, financialYear })
      .then(response => {
        //console.log(response.data); // Log response from the backend
        setIsDatabaseConnected(true);
        setLoading1(false);
      })
      .catch(error => {
        console.error('Error connecting to the database:', error);
        toast.error('Please Enter Valid Company Database Code', { position: toast.POSITION.BOTTOM_CENTER });
      });
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <ToastContainer />
      {loading && <CircularProgress sx={{ color: 'white' }} />}
      {!loading && (<Paper elevation={3} sx={{ padding: '20px', maxWidth: '400px', margin: '0 auto' }}>
        <Typography variant="h5" align="center" gutterBottom>
          {!isDatabaseConnected ? (
            "Enter Credentials"
          ) : (changePasswordMode ? 'Change Password' : 'Login')
          }
        </Typography>


        {!changePasswordMode && changePasswordMode || (
          <>
            {!isDatabaseConnected && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Client ID*"
                    variant="outlined"
                    name="ClientID"
                    placeholder="Enter Client ID*"
                    value={clientId}
                    onChange={handleClientIdChange}
                    error={passwordError}
                    InputLabelProps={{ style: passwordError ? { color: 'red' } : { color: 'white' } }}
                    InputProps={{
                      style: { borderColor: passwordError ? 'red' : '' },
                      endAdornment: passwordError ? (
                        <InputAdornment position="end">
                          <ErrorOutlineIcon color="error" />
                        </InputAdornment>
                      ) : null,
                    }}
                    sx={{ marginBottom: '10px' }}
                  />
                </Grid>
                {!isDatabaseConnected && !changePasswordMode && changePasswordMode || (
                  <>
                    <Grid item xs={12}>
                      <TextField
                        label={changePasswordMode ? "Old Password" : "Password"}
                        type="password"
                        fullWidth
                        value={changePasswordMode ? oldDBPassword : DBpassword}
                        onChange={changePasswordMode ? handleOldDBPasswordChange : handleDBPassword}
                        required
                        error={passwordError}
                        InputLabelProps={{ style: passwordError ? { color: 'red' } : { color: 'white' } }}
                        InputProps={{
                          style: { borderColor: passwordError ? 'red' : '' }, // Change border color
                          endAdornment: passwordError ? (
                            <InputAdornment position="end">
                              <ErrorOutlineIcon color="error" />
                            </InputAdornment>
                          ) : null,
                        }}
                        sx={{ marginBottom: '10px' }}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            )}

            {!isDatabaseConnected && changePasswordMode && (
              <>
                <Grid item xs={12}>
                  <TextField
                    label="New Password"
                    type="password"
                    fullWidth
                    value={newDBPassword}
                    onChange={handleNewDBPasswordChange}
                    sx={{ marginBottom: '10px' }}
                    required
                  />
                </Grid>
              </>
            )}

            {!isDatabaseConnected && changePasswordMode && (
              <>
                <Grid item xs={12}>
                  <TextField
                    label="Confirm Password"
                    type="password"
                    fullWidth
                    value={confirmDBPassword}
                    onChange={handleConfirmDBPasswordChange}
                    sx={{ marginBottom: '10px' }}
                    required
                  />
                </Grid>
              </>
            )}

            {isCredentialsValidated && !isDatabaseConnected && (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  select
                  label="Select Year"
                  value={financialYear}
                  onChange={(e) => {
                    const selectedGroupName = e.target.value;
                    setFinancialYear(selectedGroupName);
                  }}
                  variant="outlined"
                >
                  {yearMasterEntries.map((year) => (
                    <MenuItem key={year.FinancialYear} value={year.FinancialYear}>
                      {year.FinancialYear}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            )}
            <br></br>
            {!isDatabaseConnected && (
              <Grid item xs={12} container justifyContent="center">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={!financialYear ? (changePasswordMode ? handleChangeDBPassword : handleDBSubmit) : connectToDatabase}
                  sx={{ width: '100%', marginBottom: '10px' }}
                >
                  {!financialYear ? (
                    loading1 ? 
                      <CircularProgress size={28} sx={{ color: 'black' }} />
                     : (
                      changePasswordMode ? 'Update Password' : 'Login'
                    )
                  ) : (
                    loading1 ? (
                      <CircularProgress size={28} sx={{ color: 'black' }} />
                    ) : (
                      'Connect to Database'
                    )
                  )}
                </Button>
              </Grid>
            )}

            {!isDatabaseConnected && (
              <>
                <Grid item xs={12}>
                  <Button
                    type="button"
                    variant="outlined"
                    fullWidth
                    onClick={handleToggleChangePassword}
                    sx={{ color: '#fff' }}
                  >
                    {changePasswordMode ? 'Cancel Change Password' : 'Change Password'}
                  </Button>
                </Grid>
              </>
            )}
          </>
        )}

        {isDatabaseConnected && <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {!changePasswordMode && changePasswordMode || (
              <>
                <Grid item xs={12}>
                  <TextField
                    label="Username"
                    variant="outlined"
                    name="Username"
                    fullWidth
                    value={username}
                    onChange={handleUsername}
                    required
                    error={usernameError}
                    InputLabelProps={{ style: usernameError ? { color: 'red' } : { color: 'white' } }}
                    InputProps={{
                      style: { borderColor: usernameError ? 'red' : '' }, // Change border color
                      endAdornment: usernameError ? (
                        <InputAdornment position="end">
                          <ErrorOutlineIcon color="error" />
                        </InputAdornment>
                      ) : null,
                    }}
                    sx={{ marginBottom: '10px' }}
                  />
                </Grid>
              </>
            )}
            {!changePasswordMode && changePasswordMode || (
              <>
                <Grid item xs={12}>
                  <TextField
                    label={changePasswordMode ? "Old Password" : "Password"}
                    type="password"
                    fullWidth
                    value={changePasswordMode ? oldPassword : password}
                    onChange={changePasswordMode ? handleOldPasswordChange : handlePassword}
                    required
                    error={usernameError}
                    InputLabelProps={{ style: usernameError ? { color: 'red' } : { color: 'white' } }}
                    InputProps={{
                      style: { borderColor: usernameError ? 'red' : '' }, // Change border color
                      endAdornment: usernameError ? (
                        <InputAdornment position="end">
                          <ErrorOutlineIcon color="error" />
                        </InputAdornment>
                      ) : null,
                    }}
                  />
                </Grid>
              </>
            )}
            {changePasswordMode && (
              <>
                <Grid item xs={12}>
                  <TextField
                    label="New Password"
                    type="password"
                    fullWidth
                    value={newPassword}
                    onChange={handleNewPasswordChange}
                    required
                  />
                </Grid>
              </>
            )}
            {changePasswordMode && (
              <>
                <Grid item xs={12}>
                  <TextField
                    label="Confirm Password"
                    type="password"
                    fullWidth
                    value={confirmPassword}
                    onChange={handleConfirmPasswordChange}
                    required
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                fullWidth
                onClick={changePasswordMode ? handleChangePassword : handleSubmit}
              >
                {loading1 ? <CircularProgress size={28} sx={{color:'black'}}/>:(changePasswordMode ? 'Update Password' : 'Login')}
              </Button>
            </Grid>

            <Grid item xs={12}>
              <Button
                type="button"
                variant="outlined"
                fullWidth
                onClick={handleToggleChangePassword}
                sx={{ color: '#fff' }}
              >
                {changePasswordMode ? 'Cancel Change Password' : 'Change Password'}
              </Button>
            </Grid>
          </Grid>
        </form>}
      </Paper>)}
    </ThemeProvider>
  );
};

export default LoginForm;




















// import React, { useState, useEffect } from 'react';
// import {
//   TextField,
//   Button,
//   Paper,
//   Typography,
//   Grid,
//   Radio,
//   RadioGroup,
//   MenuItem,
//   FormControlLabel,
//   FormControl,
//   CircularProgress,
//   createTheme,
//   ThemeProvider,
// } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { InputAdornment } from '@mui/material';
// import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
// import axios from 'axios';

// const darkTheme = createTheme({
//   palette: {
//     mode: 'dark',
//     primary: {
//       main: '#fff', // Adjust the color according to your preference
//     },
//     background: {
//       default: '#333', // Adjust the color according to your preference
//       paper: '#333', // Adjust the color according to your preference
//     },
//     text: {
//       primary: '#fff', // Adjust the color according to your preference
//     },
//   },
// })

// const LoginForm = ({ onLoginSuccess }) => {
//   const [yearMasterEntries, setYearMasterEntries] = useState([]);
//   const [companyMasterEntries, setCompanyMasterEntries] = useState([]);
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [changePasswordMode, setChangePasswordMode] = useState(false);
//   const [oldPassword, setOldPassword] = useState('');
//   const [newPassword, setNewPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');

//   const [oldDBPassword, setOldDBPassword] = useState('');
//   const [newDBPassword, setNewDBPassword] = useState('');
//   const [confirmDBPassword, setConfirmDBPassword] = useState('');

//   const [error, setError] = useState(null);
//   const [usernameError, setUsernameError] = useState(false);
//   const [passwordError, setPasswordError] = useState(false);
//   const [clientIdError, setClientIdError] = useState(false);

//   const [isDatabaseConnected, setIsDatabaseConnected] = useState(false);
//   const [isCredentialsValidated, setIsCredentialsValidated] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [loading1, setLoading1] = useState(false); 

//   const [CompCode, setCompCode] = useState('');
//   const [companyCode, setCompanyCode] = useState('');
//   const [dbcompanyCode, setdbcompanyCode] = useState('');
//   const [financialYear, setFinancialYear] = useState('');

//   const [clientId, setClientId] = useState('');
//   const [DBpassword, setDBPassword] = useState('');

//   // const [loading, setLoading] = useState(false); // Introduce loading state

//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchCompanyMaster();
//     //fetchYearMaster();

//   }, []);

//   const fetchCompanyMaster = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get('https://www.wingap.net.in/api/company_code');
//       setLoading(false);
//       setCompanyMasterEntries(response.data);
//       setCompanyCode(response.data[0].CompCode);
//      // console.log(response);
//     } catch (error) {
//       console.log('error:', error);
//     }
//   };

//   const fetchYearMaster = async (compCode) => {
//     try {
//       console.log("Year Master CompCode ", compCode);
//       const response = await axios.get(`https://www.wingap.net.in/api/database_year_master/${compCode}`);
//       setYearMasterEntries(response.data);
//       setFinancialYear(response.data[0].FinancialYear);
//       //console.log(response);
//     } catch (error) {
//       console.log('error:', error);
//     }
//   };

//   const handleUsername = (event) => {
//     setUsername(event.target.value);
//     setUsernameError(false); // Reset error state
//   };

//   const handleClientIdChange = (event) => {
//     setClientId(event.target.value);
//     setClientIdError(false);
//   };

//   const handleDBPasswordChange = (event) => {
//     setDBPassword(event.target.value);
//   };

//   const handlePassword = (event) => {
//     setPassword(event.target.value);
//     setPasswordError(false); // Reset error state
//   };

//   const handleOldPasswordChange = (event) => {
//     setOldPassword(event.target.value);
//   };

//   const handleNewPasswordChange = (event) => {
//     setNewPassword(event.target.value);
//   };

//   const handleConfirmPasswordChange = (event) => {
//     setConfirmPassword(event.target.value);
//   };

//   const handleDBPassword = (event) => {
//     setDBPassword(event.target.value);
//     setPasswordError(false); // Reset error state
//   };

//   const handleOldDBPasswordChange = (event) => {
//     setOldDBPassword(event.target.value);
//   };

//   const handleNewDBPasswordChange = (event) => {
//     setNewDBPassword(event.target.value);
//   };

//   const handleConfirmDBPasswordChange = (event) => {
//     setConfirmDBPassword(event.target.value);
//   };

//   const handleToggleChangePassword = () => {
//     setChangePasswordMode(!changePasswordMode);
//   };


//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     setLoading(true);
//     setLoading1(true);
//     try {
//       const response = await axios.post('https://www.wingap.net.in/api/login', {
//         username,
//         password,
//       });

//       if (response.status === 200) {
//         const { message, username: loggedInUsername } = response.data;
//         console.log("Message", message);
//         onLoginSuccess(loggedInUsername);
//         //canEdit(loggedInUsername);
//         //canAdd(loggedInUsername);
//         navigate('/SelectCompany');
//         setLoading(false);
//         setLoading1(false);
//       } else {
//         console.error('Failed to log in');
//         setLoading(false);
//         setLoading1(false);
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       setLoading(false);
//       setLoading1(false);
//     } finally {
//       setLoading(false);
//       setLoading1(false);
//     }
//   };

//   const handleChangePassword = async () => {
//     try {
//       const response = await fetch('https://www.wingap.net.in/api/change-password', {
//         method: 'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ username, oldPassword, newPassword }),
//       });

//       const data = await response.json();

//       if (response.ok) {
//         setUsername('');
//         setPassword('');
//         setOldPassword('');
//         setNewPassword('');
//         setConfirmPassword('');
//         handleToggleChangePassword();
//         // console.log(data.message); // Password change successful
//       } else {
//         setUsername('');
//         setPassword('');
//         setOldPassword('');
//         setNewPassword('');
//         setConfirmPassword('');
//         console.error(data.error); // Log the error message
//         alert('Password Change failed');
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       //console.log('Password change failed');
//     }
//   };

//   const handleChangeDBPassword = async () => {
//     try {
//       const response = await fetch('https://www.wingap.net.in/api/DB-change-password', {
//         method: 'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ clientId, oldDBPassword, newDBPassword }),
//       });

//       const data = await response.json();

//       if (response.ok) {
//         setClientId('');
//         setDBPassword('');
//         setOldDBPassword('');
//         setNewDBPassword('');
//         setConfirmDBPassword('');
//         handleToggleChangePassword();
//         // console.log(data.message); // Password change successful
//       } else {
//         setUsername('');
//         setPassword('');
//         setOldPassword('');
//         setNewPassword('');
//         setConfirmPassword('');
//         console.error(data.error); // Log the error message
//         alert('Password Change failed');
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       console.log('Password change failed');
//     }
//   };

//   const handleDBSubmit = async (event) => {
//     event.preventDefault();
//     setLoading1(false);

//     try {
//       const response = await fetch('https://www.wingap.net.in/api/dblogin', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ clientId, DBpassword, dbcompanyCode }),
//       });
//       if (response.ok) {
//         const responseData = await response.json();
//         const loggedInUsername = responseData.compCode;
//         console.log("USERNAME ", loggedInUsername);
//         setdbcompanyCode(loggedInUsername);
//         console.log('Login successful');
//         fetchYearMaster(loggedInUsername);

//         setIsCredentialsValidated(true);
//         setLoading1(false);
//       } else {
//         const errorResponse = await response.json();
//         console.log('Login failed');
//         toast.error(errorResponse.error, { position: toast.POSITION.BOTTOM_CENTER });
//         console.log('Error Response:', errorResponse.error);
//         setError(errorResponse.error);
//         // setUsernameError(true);
//         setPasswordError(true);
//       }
//     } catch (error) {
//       console.log('Error:', error);
//       toast.error('An unexpected error occurred.', { position: toast.POSITION.BOTTOM_CENTER });
//     }
//   };

//   const connectToDatabase = () => {
//     if (!dbcompanyCode) {
//       setUsernameError(true);
//       return;
//     }
//     setLoading1(true);

//     axios.post('https://www.wingap.net.in/connect', { dbcompanyCode, financialYear })
//       .then(response => {
//         console.log(response.data); // Log response from the backend
//         // Handle successful connection, if needed
//         setIsDatabaseConnected(true);
//         setLoading1(false);
//       })
//       .catch(error => {
//         console.error('Error connecting to the database:', error);
//         toast.error('Please Enter Valid Company Database Code', { position: toast.POSITION.BOTTOM_CENTER });
//       });
//   };

//   return (
//     <ThemeProvider theme={darkTheme}>
//       <ToastContainer />
//       {loading && <CircularProgress sx={{ color: 'white' }} />}
//       {!loading && (<Paper elevation={3} sx={{ padding: '20px', maxWidth: '400px', margin: '0 auto' }}>
//         <Typography variant="h5" align="center" gutterBottom>
//           {!isDatabaseConnected ? (
//             "Enter Credentials"
//           ) : (changePasswordMode ? 'Change Password' : 'Login')
//           }
//         </Typography>


//         {!changePasswordMode && changePasswordMode || (
//           <>
//             {!isDatabaseConnected && (
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <TextField
//                     fullWidth
//                     label="Client ID*"
//                     variant="outlined"
//                     name="ClientID"
//                     placeholder="Enter Client ID*"
//                     value={clientId}
//                     onChange={handleClientIdChange}
//                     error={passwordError}
//                     InputLabelProps={{ style: passwordError ? { color: 'red' } : { color: 'white' } }}
//                     InputProps={{
//                       style: { borderColor: passwordError ? 'red' : '' },
//                       endAdornment: passwordError ? (
//                         <InputAdornment position="end">
//                           <ErrorOutlineIcon color="error" />
//                         </InputAdornment>
//                       ) : null,
//                     }}
//                     sx={{ marginBottom: '10px' }}
//                   />

//                 </Grid>
//                 {!isDatabaseConnected && !changePasswordMode && changePasswordMode || (
//                   <>
//                     <Grid item xs={12}>
//                       <TextField
//                         label={changePasswordMode ? "Old Password" : "Password"}
//                         type="password"
//                         fullWidth
//                         value={changePasswordMode ? oldDBPassword : DBpassword}
//                         onChange={changePasswordMode ? handleOldDBPasswordChange : handleDBPassword}
//                         required
//                         error={passwordError}
//                         InputProps={{
//                           style: { borderColor: passwordError ? 'red' : '' }, // Change border color
//                           endAdornment: passwordError ? (
//                             <InputAdornment position="end">
//                               <ErrorOutlineIcon color="error" />
//                             </InputAdornment>
//                           ) : null,
//                         }}
//                         sx={{ marginBottom: '10px' }}
//                       />
//                     </Grid>
//                   </>
//                 )}
//               </Grid>
//             )}

//             {!isDatabaseConnected && changePasswordMode && (
//               <>
//                 <Grid item xs={12}>
//                   <TextField
//                     label="New Password"
//                     type="password"
//                     fullWidth
//                     value={newDBPassword}
//                     onChange={handleNewDBPasswordChange}
//                     sx={{ marginBottom: '10px' }}
//                     required
//                   />
//                 </Grid>
//               </>
//             )}

//             {!isDatabaseConnected && changePasswordMode && (
//               <>
//                 <Grid item xs={12}>
//                   <TextField
//                     label="Confirm Password"
//                     type="password"
//                     fullWidth
//                     value={confirmDBPassword}
//                     onChange={handleConfirmDBPasswordChange}
//                     sx={{ marginBottom: '10px' }}
//                     required
//                   />
//                 </Grid>
//               </>
//             )}

//             {isCredentialsValidated && !isDatabaseConnected && (
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   select
//                   label="Select Year"
//                   value={financialYear}
//                   onChange={(e) => {
//                     const selectedGroupName = e.target.value;
//                     setFinancialYear(selectedGroupName);
//                   }}
//                   variant="outlined"
//                 >
//                   {yearMasterEntries.map((year) => (
//                     <MenuItem key={year.FinancialYear} value={year.FinancialYear}>
//                       {year.FinancialYear}
//                     </MenuItem>
//                   ))}
//                 </TextField>
//               </Grid>
//             )}
//             <br></br>
//             {!isDatabaseConnected && (
//               <Grid item xs={12} container justifyContent="center">
//                 <Button
//                   variant="contained"
//                   color="primary"
//                   onClick={!financialYear ? (changePasswordMode ? handleChangeDBPassword : handleDBSubmit) : connectToDatabase}
//                   sx={{ width: '100%', marginBottom: '10px' }}
//                 >
//                   {!financialYear ? (
//                     loading1 ? 
//                       <CircularProgress size={28} sx={{ color: 'black' }} />
//                      : (
//                       changePasswordMode ? 'Update Password' : 'Login'
//                     )
//                   ) : (
//                     loading1 ? (
//                       <CircularProgress size={28} sx={{ color: 'black' }} />
//                     ) : (
//                       'Connect to Database'
//                     )
//                   )}
//                 </Button>
//               </Grid>
//             )}

//             {!isDatabaseConnected && (
//               <>
//                 <Grid item xs={12}>
//                   <Button
//                     type="button"
//                     variant="outlined"
//                     fullWidth
//                     onClick={handleToggleChangePassword}
//                     sx={{ color: '#fff' }}
//                   >
//                     {changePasswordMode ? 'Cancel Change Password' : 'Change Password'}
//                   </Button>
//                 </Grid>
//               </>
//             )}
//           </>
//         )}

//         {isDatabaseConnected && <form onSubmit={handleSubmit}>
//           <Grid container spacing={2}>
//             {!changePasswordMode && changePasswordMode || (
//               <>
//                 <Grid item xs={12}>
//                   <TextField
//                     label="Username"
//                     fullWidth
//                     value={username}
//                     onChange={handleUsername}
//                     required
//                     error={usernameError}
//                     InputProps={{
//                       style: { borderColor: usernameError ? 'red' : '' }, // Change border color
//                       endAdornment: usernameError ? (
//                         <InputAdornment position="end">
//                           <ErrorOutlineIcon color="error" />
//                         </InputAdornment>
//                       ) : null,
//                     }}
//                   />
//                 </Grid>
//               </>
//             )}
//             {!changePasswordMode && changePasswordMode || (
//               <>
//                 <Grid item xs={12}>
//                   <TextField
//                     label={changePasswordMode ? "Old Password" : "Password"}
//                     type="password"
//                     fullWidth
//                     value={changePasswordMode ? oldPassword : password}
//                     onChange={changePasswordMode ? handleOldPasswordChange : handlePassword}
//                     required
//                     error={passwordError}
//                     InputProps={{
//                       style: { borderColor: passwordError ? 'red' : '' }, // Change border color
//                       endAdornment: passwordError ? (
//                         <InputAdornment position="end">
//                           <ErrorOutlineIcon color="error" />
//                         </InputAdornment>
//                       ) : null,
//                     }}
//                   />
//                 </Grid>
//               </>
//             )}
//             {changePasswordMode && (
//               <>
//                 <Grid item xs={12}>
//                   <TextField
//                     label="New Password"
//                     type="password"
//                     fullWidth
//                     value={newPassword}
//                     onChange={handleNewPasswordChange}
//                     required
//                   />
//                 </Grid>
//               </>
//             )}
//             {changePasswordMode && (
//               <>
//                 <Grid item xs={12}>
//                   <TextField
//                     label="Confirm Password"
//                     type="password"
//                     fullWidth
//                     value={confirmPassword}
//                     onChange={handleConfirmPasswordChange}
//                     required
//                   />
//                 </Grid>
//               </>
//             )}

//             {/* <Grid item xs={12}>
//           <Button
//             type="button"
//             variant="outlined"
//             fullWidth
//             onClick={changePasswordMode ? handleChangePassword : handleToggleChangePassword}
//           >
//             {changePasswordMode ? 'Update Password' : 'Change Password'}
//           </Button>
//         </Grid> */}

//             {/* <Grid item xs={12} >
//             <Button 
//               type="submit" 
//               variant="contained" 
//               fullWidth 
//               onClick={changePasswordMode ? handleChangePassword : handleSubmit}
//             >
//               {changePasswordMode ? 'Update Password' : 'Login'}
//             </Button>
//           </Grid> */}

//             <Grid item xs={12}>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 fullWidth
//                // disabled={loading}
//                 onClick={changePasswordMode ? handleChangePassword : handleSubmit}
//               >
//                 {loading1 ? <CircularProgress size={28} sx={{color:'black'}}/>:(changePasswordMode ? 'Update Password' : 'Login')}
//               </Button>
//             </Grid>

//             <Grid item xs={12}>
//               <Button
//                 type="button"
//                 variant="outlined"
//                 fullWidth
//                 onClick={handleToggleChangePassword}
//                 sx={{ color: '#fff' }}
//               >
//                 {changePasswordMode ? 'Cancel Change Password' : 'Change Password'}
//               </Button>
//             </Grid>
//           </Grid>
//         </form>}
//       </Paper>)}
//     </ThemeProvider>
//   );
// };

// export default LoginForm;

